import * as t from 'io-ts';
import {
  group as groupCodec,
  groupedInspectionCodec,
  groupedInspectionListCodec,
  groupedIssueCodec,
  groupedIssueListCodec, groupedIssueListCodecMeta,
  groupedQuestionCodec,
  groupedQuestionListCodec,
  inspectionCodec,
  inspectionListCodec,
  issueCodec,
  issueListCodec,
  questionCodec,
  questionListCodec,
  purchaseCodec,
} from '@/services/api/resources/analytics';
import { emptyMeta } from '@/services/api';

export type Inspection = t.TypeOf<typeof inspectionCodec>;
export type InspectionList = t.TypeOf<typeof inspectionListCodec>;
export type GroupedInspection = t.TypeOf<typeof groupedInspectionCodec>;
export type GroupedInspectionList = t.TypeOf<typeof groupedInspectionListCodec>;

export type Issue = t.TypeOf<typeof issueCodec>;
export type IssueList = t.TypeOf<typeof issueListCodec>;
export type GroupedIssue = t.TypeOf<typeof groupedIssueCodec>;
export type GroupedIssueList = t.TypeOf<typeof groupedIssueListCodec>;
export type GroupedIssueListMeta = t.TypeOf<typeof groupedIssueListCodecMeta>;

export type Question = t.TypeOf<typeof questionCodec>;
export type QuestionList = t.TypeOf<typeof questionListCodec>;
export type GroupedQuestion = t.TypeOf<typeof groupedQuestionCodec>;
export type GroupedQuestionList = t.TypeOf<typeof groupedQuestionListCodec>;

export type AnalyticsEntityGroup = t.TypeOf<typeof groupCodec>;
export type Purchase = t.TypeOf<typeof purchaseCodec>;

export type BaseGroupedEntity = {
  group: AnalyticsEntityGroup;
};

export const emptyDetailList: InspectionList & IssueList & QuestionList = {
  data: [],
  meta: emptyMeta(),
};

export const emptyGroupedInspectionList: GroupedInspectionList = {
  data: [],
  meta: {
    total: 0,
    inspectionCount: 0,
    overdueInspectionCount: 0,
    overdueInspectionPercentage: 0,
  },
};

export const emptyGroupedQuestionList: GroupedQuestionList = {
  data: [],
  meta: {
    total: 0,
    count: 0,
    responseCount: 0,
    negativeResponseCount: 0,
    negativeResponsePercentage: 0,
    maxScore: 0,
    score: 0,
    scorePercentage: 0,
  },
};

export const emptyGroupedIssueList: GroupedIssueList = {
  data: [],
  meta: {
    total: 0,
    issueCount: 0,
    overdueIssueCount: 0,
    openIssueCount: 0,
    openIssuePercentage: 0,
    inProgressIssueCount: 0,
    resolvedIssueCount: 0,
    resolvedInTimeIssueCount: 0,
    resolvedOverdueIssueCount: 0,
    averageTimeToResolve: 0,
  },
};
